/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Helpers.StrictFullNameValidator = class StrictFullNameValidator {
  constructor(fullName) {
    this.fullName = fullName;
  }

  isValid() {
    return /[^\s]+\s+[^\s]+/.test(this.fullName);
  }
};
